import { DocumentTypeVals } from './DocumentTypeVals';

export const ProjectDocFolderStatuses = {
    NoData: 1,
    OnCheck: 2,
    OnContractorDevelopment: 3,
    Approved: 4,
    OnGIPApproval: 5,
    Recalled: 6,
    ApproverWithRemarks: 7,
    New: 8,
    Sent: 9,
    CreatingNewVersion: 10,
    Accepted: 11,
    NoAccepted: 12,
    NotApproved: 13,
    OrderDocument: 14
};

export function getPDFStatusBadge(statusId?: number) {
    switch (statusId) {
        case ProjectDocFolderStatuses.NoData:
            return `badge badge-danger`;
        case ProjectDocFolderStatuses.OnCheck:
            return `badge badge-info`;
        case ProjectDocFolderStatuses.OnContractorDevelopment:
            return `badge badge-warning`;
        case ProjectDocFolderStatuses.Approved:
        case ProjectDocFolderStatuses.ApproverWithRemarks:
            return `badge badge-success`;
        case ProjectDocFolderStatuses.OnGIPApproval:
            return `badge badge-info`;
        case ProjectDocFolderStatuses.Recalled:
            return `badge badge-secondary`;
        case ProjectDocFolderStatuses.New:
            return `badge badge-warning`;
        case ProjectDocFolderStatuses.Sent:
            return `badge badge-info`;
        case ProjectDocFolderStatuses.CreatingNewVersion:
            return `badge badge-warning`;
        case ProjectDocFolderStatuses.Accepted:
            return `badge badge-success`;
        case ProjectDocFolderStatuses.NoAccepted:
        case ProjectDocFolderStatuses.NotApproved:
            return `badge badge-secondary`;
        default:
            return ``;
    }
}

export const OrderDocumentCheckedLabel = 'Проверен';

export function isCheckedOrderDocument(statusId?: number, documentTypeId?: number): boolean {
    if (documentTypeId !== DocumentTypeVals.ResponsiblePersonOrder) return false;
    return (
        statusId === ProjectDocFolderStatuses.OrderDocument ||
        statusId === ProjectDocFolderStatuses.Approved ||
        statusId === ProjectDocFolderStatuses.ApproverWithRemarks
    );
}
